type SessionHandler = (employee?: string) => void;

const sessionConfig: Record<string, SessionHandler> = {
  Laundry: (employee) => {
    sessionStorage.setItem("laundry", "Laundry_login");
    if (employee) {
      sessionStorage.setItem("employee", "login_employee");
    } else {
      sessionStorage.setItem("Noemployee", "login_employee");
    }
  },
  Restaurant: () => sessionStorage.setItem("restaurant", "Restaurant_login"),
  Carwash: () => sessionStorage.setItem("carwash", "Carwash_login"),
  "Car wash": () => sessionStorage.setItem("carwash", "Carwash_login"),
  "Vechicle retailer": () => sessionStorage.setItem("Vechicle retailer", "Vechicle-retailer"),
  Saloon: () => sessionStorage.setItem("Saloon", "Saloon"),
  Grocery: () => sessionStorage.setItem("Grocery", "Grocery"),
};

export const useBusinessSession = () => {
  const setSessionForBusiness = (businessType: string, employee?: string) => {
    const handler = sessionConfig[businessType];
    if (handler) handler(employee);
  };

  return { setSessionForBusiness };
};
